export const interiorView07ImageOptions = {
	angle:"InteriorView07",
	staticOptions:{
		PortAftCabinOptions:1,
		StarboardAftCabinOptions:1,
		Floorboard:1,
		Worktop:1,
		StarboardAftCabin:1,
		FabricSaloon:1,
		Mast:1,
		TableBox:1,
		Pouffes:1,
		FabricCabins:1,
	},
	mattes:[
		{
			option:"Veneer",
			dependency:null
		},
		{
			option:"Floorboard",
			dependency:"Pouffes"
		},
		{
			option:"FabricSaloon",
			dependency:"StarboardAftCabin"
		},
		{
			option:"CupboardsOwnersCabin",
			dependency:"Veneer"
		},
		{
			option:"FabricCabins",
			dependency:null
		},
	],
	overlays:[
	]
};



// WEBPACK FOOTER //
// ./src/X46MK2/views/InteriorView07.js